/***********************************************
	IceMedX - Developed By IceMedx Corporation
	Copyright 2011 IceMedx Corporation
***********************************************/
import { Injectable } from '@angular/core';
import { IceEntity } from '../../core/IceEntity';
import { IceTypes } from "../../icetypes";

export class superbillchargesindex extends IceEntity {
  superbill_charges_index_key: string = "";
  superbill_charges_key: string = "";
  superbill_key: string = "";
  subscriber_key: string = "";
  referral_from_key: string = "";
  from_account_type: IceTypes.ACCOUNT_TYPE = IceTypes.ACCOUNT_TYPE.actNone; // new
  from_trans_account: string = "";
  to_account_type: IceTypes.ACCOUNT_TYPE = IceTypes.ACCOUNT_TYPE.actNone; // new
  to_trans_account: string = "";
  created: any = NaN;
  modified: any = NaN;
  bill_status: IceTypes.trans_status = IceTypes.trans_status.isNone;
  bill_to: string = "";

  constructor() {
    super();
  }

  gettablename(): string {
  return "SUPERBILL_CHARGES_INDEX";
  }
}
